var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":_vm.activeFilters > 0 ? 'warning' : 'primary'},on:{"click":_vm.filtrer}},[_c('b-icon-funnel'),_c('span',{staticClass:"d-none d-md-inline"},[_vm._v(" Filtres")]),(_vm.activeFilters > 0)?_c('span',[_vm._v(" ("+_vm._s(_vm.activeFilters)+")")]):_vm._e(),_c('FiltersDialog',{ref:"filtersDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }